var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cancel-card" },
    [
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("page-info", {
            attrs: {
              title:
                "Уверены, что хотите отменить заказ №&nbsp;" + _vm.orderNumber,
              subtitle: "Пожалуйста, укажите причину отмены:"
            }
          })
        ],
        1
      ),
      _c("radio-group", {
        attrs: { options: _vm.reasons, name: "reasons" },
        model: {
          value: _vm.code,
          callback: function($$v) {
            _vm.code = $$v
          },
          expression: "code"
        }
      }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.otherReason
            ? _c("ui-textarea", {
                staticClass: "comment",
                attrs: {
                  placeholder: "Укажите причину отмены заказа",
                  height: "60"
                },
                model: {
                  value: _vm.comment,
                  callback: function($$v) {
                    _vm.comment = $$v
                  },
                  expression: "comment"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _c("ui-button", {
            attrs: {
              wide: "",
              disabled: !_vm.code || (_vm.otherReason && !_vm.comment),
              loading: _vm.progress,
              text: "Отменить заказ"
            },
            on: { click: _vm.cancelOrder }
          }),
          _c("ui-button", {
            attrs: { wide: "", secondary: "", text: "Не отменять" },
            on: {
              click: function($event) {
                return _vm.$emit("on-close")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }